// extracted by mini-css-extract-plugin
export default {"form":"FmLsa","button":"mAgev","skeleton-progress":"ej-h8"};